import { render, staticRenderFns } from "./ICombobox.vue?vue&type=template&id=61bbdcd6"
import script from "./ICombobox.vue?vue&type=script&lang=js"
export * from "./ICombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports